export const textContainerClassName = "textContainer";
export const ribbonDividerWrapperClassName = "ribbon-divider-wrapper";

export const getRibbonTextContainerSelector = (
  useOptimizedSelector: boolean
) => {
  return useOptimizedSelector
    ? `.${textContainerClassName}`
    : `[class*='${textContainerClassName}']`;
};

export const getDataUniqueIdSelector = (id: string) =>
  `[data-unique-id="${id}"]`;
